var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlignRight = function SvgAlignRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.35 17.4a.6.6 0 1 1 0 1.2H6.806a.6.6 0 1 1 0-1.2zm0-6a.6.6 0 1 1 0 1.2H8.882a.6.6 0 1 1 0-1.2zm0-6a.6.6 0 0 1 0 1.2H2.649a.6.6 0 1 1 0-1.2z"
  })));
};
export default SvgAlignRight;